import { Button, Form, Space, Switch, Table, Tag, Tooltip, message } from "antd";
import { useEffect, useState, useContext, useCallback } from "react";
import { TbPlugConnectedX } from "react-icons/tb";
import { FileContext } from "../../contexts/FileContext";
import { AddBeanstalkCredsFormData, OauthConnect } from "../IntegrateApplications/apiForm.js";
import { deleteBeanstalkCredsFromDB, storeBeanstalkCredsToDB } from "../../api/beanstalk";
import { getAllServices, deleteService } from "../../api/api_endpoints";
import { BeanstalkModal } from "../common/ApiModal";
import { getConnectionStatus } from "../../api/beanstalk";
import { axiosSecureInstance } from "../../api/axios.js";
import AddApps from "../../Pages/Account/AddApps";
import { AddApiEndpoints } from "../AddApiEndpoint/AddApiEndpoints.js"
import { useNavigate } from 'react-router-dom';

export const AdminDefinedApps = () => {
  const [form] = Form.useForm();
  const {
    isConnected,
    setIsConnected,
    token,
    setToken,
    isBeanstalkConnected,
    setIsBeanstalkConnected,
  } = useContext(FileContext);
    useContext(FileContext)
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState([])
  const [formitems, setFormitems] = useState([]);
  const [app, setApp] = useState([]);
  const [applicationsData, setApplicationsData] = useState([])
  const [isBeanstalkModalOpen, setIsBeanstalkModalOpen] = useState(false)
  const [serviceid, setServiceId] = useState("")
  const [datasource, setDatasource] = useState([])
  const [showAddApi, setShowAddApi] = useState(false)
  const navigate = useNavigate()

  const allServices = useCallback(async () => {
    const services = await getAllServices()
    setApiResponse(services.data.data)
  }, [])

  const fetchApps = useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await axiosSecureInstance.get(`${process.env.REACT_APP_BASE_URL}api/get-apps`)
      const apps = response.data.apps.map((app) => ({
        key: app._id,
        name: app.service_name,
        slug: app.slug,
        status: app.is_active ? "Connected" : "Disconnected",
        icon: (
          <img
            src={app.service_icon || "/placeholder.svg"}
            alt={`${app.service_name} Icon`}
            style={{ width: 25, height: 25, marginRight: 9, marginLeft: 0, alignItems: "left" }}
          />
        ),
        isConnected: app.is_active,
      }))
      setApplicationsData(apps)
    } catch (error) {
      console.error("Error fetching apps:", error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    allServices()
    fetchApps()
  }, [allServices, fetchApps])

  useEffect(() => {
    const fetchConnectionStatuses = async () => {
      if (apiResponse.length === 0) return

      const appsWithConnection = await Promise.all(
        apiResponse.map(async (record) => {
          const isConnected = await checkServiceConnection(record._id)
          return {
            name: record.service_name,
            isConnected,
            connect: (
              service_id,
              authType,
              authFields,
              authenticateFields,
              oauthurl,
              tokenurl,
              baseurl,
              type,
              contentType,
            ) =>
              handleBeanstalkConnect(
                service_id,
                authType,
                authFields,
                authenticateFields,
                oauthurl,
                tokenurl,
                baseurl,
                type,
                contentType,
              ),
            disconnect: (service_id, authType) => handleBeanstalkDisconnect(service_id, authType),
          };
        })
      );

      setApp(appsWithConnection);
    };

    fetchConnectionStatuses();
  }, [apiResponse]);

  const handleAddApp = useCallback(
    (appName, appIconUrl, fields) => {
      allServices()
      fetchApps()
    },
    [allServices, fetchApps],
  )

  const handleBeanstalkConnect = async (
    service_id,
    authType,
    authFields,
    authenticateFields,
    oauthurl,
    tokenurl,
    baseurl,
    type,
    contentType,
  ) => {
    setServiceId(service_id)
    if (authType == "OAuth") {
      const response = await OauthConnect(
        service_id,
        authFields,
        authenticateFields,
        oauthurl,
        tokenurl,
        baseurl,
        type,
        contentType,
      )
      const { authorizationUrl } = response;
      window.location.href = authorizationUrl;
    } else {
      const items = await AddBeanstalkCredsFormData(service_id);
      setFormitems(items);
      setIsBeanstalkModalOpen(true);
    }
  }

  const handleBeanstalkDisconnect = async (service_id) => {
    const responseOfBeanstalkCredsDelete = await deleteBeanstalkCredsFromDB(service_id);
    if (responseOfBeanstalkCredsDelete.status === 200) {
      setIsBeanstalkConnected(false);
      message.success(responseOfBeanstalkCredsDelete.data.message);
    } else {
      message.error(responseOfBeanstalkCredsDelete.data.message);
    }
    return responseOfBeanstalkCredsDelete;
  }

  const handleAddApis = () => {
    setShowAddApi(true);
  };

  const closeAddApi = () => {
    setShowAddApi(false);
  };

  const checkServiceConnection = async (service_id) => {
    const status = await getConnectionStatus(service_id);
    return status;
  };

  const handleDeleteApps = async (serviceId) => {
    setIsLoading(true);
    try {
      await deleteService(serviceId)

      await fetchApps()
      await allServices()

      message.success('App deleted successfully!');
    } catch (error) {
      console.error("Error deleting service:", error);
      message.error('Failed to delete app. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const updatedApplicationData = apiResponse.map((record) => ({
    key: record._id,
    name: record.service_name,
    service_id: record._id,
    icon: (
      <img
        src={`${process.env.REACT_APP_BASE_URL}${record.service_icon}`}
        alt={`${record.service_name} Icon`}
        style={{
          width: 25,
          height: 25,
          marginRight: 9,
          marginLeft: 0,
          alignItems: 'left',
        }}
      />
    ),
    authType: record.authType,
    authFields: record.authFields,
    authenticateFields: record.authenticateFields,
    oauthurl: record.oauthurl ?? '',
    tokenurl: record.tokenurl ?? '',
    baseurl: record.baseurl ?? '',
    type: record.type ?? '',
    contentType: record.contentType ?? '',
    is_active: record.is_active,
  }));

  const handleToggleActive = async (record) => {
    const newIsActive = !record.is_active
    try {
      const response = await axiosSecureInstance.patch(
        `${process.env.REACT_APP_BASE_URL}api/integration/update-service-status/${record.service_id}`,
        { is_active: newIsActive }
      );
      if (response.status === 200) {
        setApiResponse((prevResponse) =>
          prevResponse.map((item) => (item._id === record.service_id ? { ...item, is_active: newIsActive } : item)),
        )
        await fetchApps()
      } else {
        message.error("Failed to update app status. Please try again.")
      }
    } catch (error) {
      console.error("Error updating service status:", error);
      message.error("Failed to update app status. Please try again.")
    }
  }

  const handleBeanstalkInstertCreds = async (formItems) => {
    form
      .validateFields()
      .then(async (values) => {
        const groupedValues = {
          authFields: {},
          headers: {},
          otherFields: {},
        };

        formItems.forEach((item) => {
          if (item.group === "authFields") {
            groupedValues.authFields[item.name] = values[item.name];
          } else if (item.group === "headers") {
            groupedValues.headers[item.name] = values[item.name];
          } else {
            groupedValues.otherFields[item.name] = values[item.name];
          }
        })

        try {
          const responseOfKeyStore = await storeBeanstalkCredsToDB(groupedValues, serviceid);

          await fetchApps()

          setIsBeanstalkConnected(true);
          setIsBeanstalkModalOpen(false);
          message.success(responseOfKeyStore.data.message);
          form.resetFields();
        } catch (error) {
          console.error("Error storing credentials:", error);
          message.error("Failed to store credentials. Please try again.")
        }
      })
      .catch((errorInfo) => {
        message.error("Validation failed. Please check the input fields.")
      })
  }

  const columns = [
    {
      title: 'Application',
      dataIndex: 'name',
      key: 'name',
      align: 'start',
      render: (text, record) => (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', fontSize: '16px' }}>
          {record.icon}
          <b>{text}</b>
        </span>
      ),
    },
    {
      title: 'Activate',
      dataIndex: 'activate',
      key: 'activate',
      align: 'center',
      render: (_, record) => <Switch checked={record.is_active} onChange={() => handleToggleActive(record)} />,
    },
    {
      title: 'Is Active',
      dataIndex: 'isActive',
      key: 'isActive',
      align: 'center',
      render: (_, record) => (
        <Tag color={record.is_active ? "green" : "red"}>{record.is_active ? "Active" : "Not Active"}</Tag>
      ),
    },
    {
      title: "API Management",
      dataIndex: "apiManagement",
      key: "apiManagement",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title={"Add API's"}>
            <Button onClick={() => handleAddApis(record.service_id)}>Add API's</Button>
          </Tooltip>
        </Space>
      ),
    },
    {
      title: 'Delete App',
      dataIndex: 'deleteapp',
      key: 'deleteapp',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Tooltip title={"Delete APP"}>
            <Button onClick={() => handleDeleteApps(record.service_id)}>Remove</Button>
          </Tooltip>
        </Space>
      ),
    },
  ]

  const handleInputModalClose = () => {
    setIsBeanstalkModalOpen(false);
  }

  return (
    <div style={{ margin: "20px" }}>
      {showAddApi ? (
        <div>
          <AddApiEndpoints onClose={closeAddApi} />
        </div>
      ) : (
        <>
          <div className="connect-apps-container">
            <div className="large-icon-container connect-app-container">
              <TbPlugConnectedX className="large-icon lg" />
              <span>Connect Apps</span>
            </div>
            <AddApps onAddApp={handleAddApp} />
          </div>

          <Table
            loading={isLoading}
            bordered={true}
            columns={columns}
            dataSource={updatedApplicationData}
            pagination={false}
          />

          <BeanstalkModal
            propsData={{
              title: "Required Fields to Connect the Service",
              data: null,
              placeholder: "",
              open: isBeanstalkModalOpen,
              onCancel: handleInputModalClose,
              onOk: handleBeanstalkInstertCreds,
              okText: "Add",
              formItems: Array.isArray(formitems) ? formitems : [],
              form: form,
            }}
          />
        </>
      )}
    </div>
  );
};

export default AdminDefinedApps;

